import { PageNotFoundMessage } from './page-not-found-message'

export default PageNotFoundMessage
